import { render, staticRenderFns } from "./addzyk.vue?vue&type=template&id=f72348b6&scoped=true"
import script from "./addzyk.vue?vue&type=script&lang=js"
export * from "./addzyk.vue?vue&type=script&lang=js"
import style0 from "./addzyk.vue?vue&type=style&index=0&id=f72348b6&prod&lang=less&scoped=true"
import style1 from "./addzyk.vue?vue&type=style&index=1&id=f72348b6&prod&lang=less"
import style2 from "./addzyk.vue?vue&type=style&index=2&id=f72348b6&prod&lang=less"
import style3 from "./addzyk.vue?vue&type=style&index=3&id=f72348b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72348b6",
  null
  
)

export default component.exports